var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.72917 1.72928C0.774178 2.68427 0.774178 4.23263 1.72917 5.18762L18.8124 22.2708C19.7674 23.2258 21.3157 23.2258 22.2707 22.2708C23.2257 21.3158 23.2257 19.7675 22.2707 18.8125L5.18752 1.72928C4.23253 0.77428 2.68417 0.77428 1.72917 1.72928Z",
    fill: "#212121"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2712 1.72917C21.3162 0.774178 19.7678 0.774178 18.8128 1.72917L1.72962 18.8124C0.774627 19.7674 0.774627 21.3157 1.72962 22.2707C2.68462 23.2257 4.23298 23.2257 5.18797 22.2707L22.2712 5.18752C23.2262 4.23253 23.2262 2.68417 22.2712 1.72917Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseMenuIcon);
export default __webpack_public_path__ + "static/media/close-menu-icon.58767882e12433168ab55e7025d9fbaa.svg";
export { ForwardRef as ReactComponent };